import React, { useState, useEffect } from 'react';

const Courses = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // Testimonial data
  const testimonials = [
    {
      id: 1,
      image: "img/testimonial-1.jpg",
      name: "Rahul Sharma",
      profession: "B.Com Graduate, 2023",
      text: "The B.Com program at M.C.M College provided me with excellent business fundamentals. The faculty was supportive and the curriculum was industry-relevant."
    },
    {
      id: 2,
      image: "img/testimonial-2.jpg",
      name: "Priya Patel",
      profession: "BBA Student",
      text: "The BBA program's focus on practical learning and case studies has prepared me well for the corporate world. Great campus facilities!"
    },
    {
      id: 3,
      image: "img/testimonial-3.jpg",
      name: "Amit Kumar",
      profession: "B.A Graduate, 2022",
      text: "The multidisciplinary approach in B.A program helped me develop critical thinking skills. The digital library resources were extremely helpful."
    },
    {
      id: 4,
      image: "img/testimonial-4.jpg",
      name: "Sneha Reddy",
      profession: "Digital Marketing Student",
      text: "The skill development programs are excellent. I gained practical digital marketing skills that helped me start my freelance career."
    }
  ];

  // Course data
  const degreePrograms = [
    {
      id: 1,
      title: "B.Com (Bachelor of Commerce)",
      image: "img/cat-2.jpg",
      category: "Bachelor's Degree",
      duration: "3 Years",
      mode: "On-campus",
      description: "Comprehensive commerce education covering accounting, finance, business law, and economics. Prepares students for careers in business, finance, and management.",
      specializations: [
        "Accounting & Financial Management",
        "Business Law & Ethics",
        "Taxation & Auditing",
        "Corporate Finance"
      ]
    },
    {
      id: 2,
      title: "Bachelor of Business Administration (BBA)",
      image: "img/cat-3.jpg",
      category: "Bachelor's Degree",
      duration: "3 Years",
      mode: "On-campus",
      description: "Develop leadership and management skills for the global business environment. Focus on strategic thinking, entrepreneurship, and organizational management.",
      specializations: [
        "Strategic Management",
        "Marketing & Sales",
        "Human Resource Management",
        "Operations Management"
      ]
    },{
      id: 3,
      title: "Bachelor of Arts (BA)",
      image: "img/cat-4.jpg",
      category: "Bachelor's Degree",
      duration: "3 Years",
      mode: "On-campus",
      description: "Develop leadership and management skills for the global business environment. Focus on strategic thinking, entrepreneurship, and organizational management.",
      specializations: [
        "Strategic Management",
        "Marketing & Sales",
        "Human Resource Management",
        "Operations Management"
      ]
    },
    // {
    //   id: 3,
    //   title: "B.A (Multidisciplinary Arts Program)",
    //   image: "img/baaa1.jpg",
    //   category: "Bachelor's Degree",
    //   duration: "3 Years",
    //   mode: "On-campus",
    //   description: "A unique interdisciplinary program combining humanities, social sciences, and creative arts. Develop critical thinking, research skills, and cultural understanding.",
    //   specializations: [
    //     "Literature & Cultural Studies",
    //     "Psychology & Sociology",
    //     "Political Science & Economics",
    //     "History & Philosophy"
    //   ],
    //   electives: [
    //     "Digital Media & Communication",
    //     "Environmental Studies",
    //     "Creative Writing",
    //     "Foreign Languages"
    //   ]
    // }
  ];

  const skillPrograms = [
    {
      id: 1,
      title: "Digital Marketing Mastery",
      image: "img/digital.jpg",
      category: "Professional Certificate",
      duration: "3 Months",
      mode: "Online",
      description: "Comprehensive digital marketing training covering SEO, social media, content marketing, and analytics. Learn to create effective digital campaigns.",
      highlights: [
        "SEO & SEM Strategies",
        "Social Media Marketing",
        "Content Creation & Marketing",
        "Analytics & Performance Tracking"
      ]
    },
    {
      id: 2,
      title: "Data Analytics & Visualization",
      image: "img/data.jpg",
      category: "Professional Certificate",
      duration: "3 Months",
      mode: "Online",
      description: "Master data analysis tools and techniques. Learn to extract insights from data and create compelling visualizations for decision making.",
      highlights: [
        "Data Analysis with Python/R",
        "Statistical Methods",
        "Tableau & Power BI",
        "Predictive Modeling"
      ]
    }
  ];

  const shortCourses = [
    {
      id: 1,
      title: "Information Technology",
      category: "Short Course",
      description: "Information technology (IT) is concerned with technology to treat information. The acquisition, processing, storage and dissemination of vocal, pictorial, textual and numerical information by a microelectronics-based combination of \"Computing\" and \"Telecommunications\" are its main fields.."
    },
    {
      id: 2,
      title: "Diploma in IT",
      category: "Short Course",
      description: "The diploma is normally taken following a Bachelor's degree and a successful award allows progression to a Masters Degree without having received Honours with the Bachelor's Degree in the field \"Information Technology(IT)\"."
    },
    {
      id: 3,
      title: "Web Designing & Development",
      category: "Short Course",
      description: "The Web Design & Development is an introduction to the design, creation, and maintenance of web pages and websites."
    },
    {
      id: 4,
      title: "Multimedia & Animation",
      category: "Short Course",
      description: "Multimedia is a \"Combination of more than one media\" to present the information and animation deals with the \"Creation of effective visual motion\" of information."
    },
    {
      id: 5,
      title: "Certified Programs on Hardware & Networking",
      category: "Short Course",
      description: "With ever dropping prices of hardware devices, the market for networking devices and systems is undergoing a kind of change that can be loosely termed as ‘generalization’.."
    }
  ];

  // Testimonial slider functionality
  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonial();
    }, 4000);
    
    return () => clearInterval(interval);
  }, [currentTestimonial]);

  const nextTestimonial = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
      setIsAnimating(false);
    }, 500);
  };

  const prevTestimonial = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
      setIsAnimating(false);
    }, 500);
  };

  const goToTestimonial = (index) => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentTestimonial(index);
      setIsAnimating(false);
    }, 500);
  };

  const handleApplyClick = (courseTitle) => {
    console.log(`Applying for: ${courseTitle}`);
    // Add your application logic here
  };

  const handleEnrollClick = (courseTitle) => {
    console.log(`Enrolling in: ${courseTitle}`);
    // Add your enrollment logic here
  };

  const handleViewDetails = (courseTitle) => {
    console.log(`Viewing details for: ${courseTitle}`);
    // Add your details logic here
  };

  return (
    <>
      {/* Page Header */}
      <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="display-3 text-white animated slideInDown">Courses</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="">
    <a className="text-white" href="">Home</a>
  </li>

  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  </li>

  <li className=" active text-white" aria-current="page">
    Courses
  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Main Courses Section */}
      <section className="section gb nopadtop">
        <div className="container">
          <div className="boxed">
            <div className="row">
              <div className="col-md-12">
                {/* Featured Course Section */}
                <div className="section-titlee" id="featured">
                  <h6 className="section-title bg-white text-start text-primary pe-3">Featured Course</h6>
                  <h3>Our Flagship Programs</h3>
                  <p className="mb-4">Explore our comprehensive degree programs designed to shape future leaders</p>
                </div>

                {/* Degree Programs */}
                <div className="section-titlee mt-5">
                  <h6 className="section-title bg-white text-start text-primary pe-3">Degree Programs</h6>
                  <h3>Bachelor's Degrees</h3>
                  <p className="mb-4">Three-year undergraduate programs with industry-relevant curriculum</p>
                </div>
                
                {degreePrograms.map((program) => (
                  <div key={program.id} className="row mb-5" id={`program-${program.id}`}>
                    <div className="col-md-12">
                      <div className="course-card border rounded overflow-hidden shadow-sm hover-lift">
                        <div className="row g-0">
                          <div className="col-md-4">
                            <div className="course-img h-100">
                              <img 
                                src={program.image} 
                                alt={program.title}
                                className="img-fluid w-100 h-100"
                                style={{ objectFit: 'cover' }}
                              />
                            </div>
                          </div>
                          <div className="col-md-8">
                            <div className="course-content p-4 h-100">
                              <span className={`course-category ${program.category === "Bachelor's Degree" ? 'degree' : 'skill'}`}>
                                {program.category}
                              </span>
                              <h4 className="mt-2 mb-3">{program.title}</h4>
                              <p className="mb-3">{program.description}</p>
                              
                              <div className="course-details mb-3">
                                <span className="course-duration me-4">
                                  <i className="fa fa-clock-o me-1"></i> {program.duration}
                                </span>
                                <span className="course-mode">
                                  <i className="fa fa-laptop me-1"></i> {program.mode}
                                </span>
                              </div>
                              
                              <div className="row">
                                <div className="col-md-6">
                                  <h5 className="mb-3">Core Specializations:</h5>
                                  <ul className="course-highlights list-unstyled">
                                    {program.specializations.map((spec, index) => (
                                      <li key={index} className="mb-2">
                                        <i className="fa fa-check text-primary me-2"></i>
                                        {spec}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                
                                {program.electives && (
                                  <div className="col-md-6">
                                    <h5 className="mb-3">Elective Options:</h5>
                                    <ul className="course-highlights list-unstyled">
                                      {program.electives.map((elective, index) => (
                                        <li key={index} className="mb-2">
                                          <i className="fa fa-check text-primary me-2"></i>
                                          {elective}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                              
                              <div className="row mt-4">
                                <div className="col-6">
                                  {/* Optional: Add pricing if needed */}
                                  {/* <div className="course-price">$2,499 <span>/ year</span></div> */}
                                </div>
                                <div className="col-6 text-end">
                                 
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Skill Development Programs */}
                <div className="section-titlee mt-5">
                  <h6 className="section-title bg-white text-start text-primary pe-3">Skill Development</h6>
                  <h3>Eligibility for Admission</h3>
                  <p className="mb-4">The candidates seeking admission must have passed Pre –University/Higher Secondary/10+2 examinations or equivalent /Any Recognized Board/Council in any discipline. The candidate who has successfully completed Three years of Polytechnic Diploma from State Technical Board after 10th Standard is also eligible for Admission. Foreign Students whose eligibility is approved by University of Mysore is eligible for Admission</p>
                  <h3>Syllabus and Duration of the course</h3>
                  <p className="mb-4">The course is conducted as per the syllabus prescribed by University of Mysore. The duration of the course is six semesters.
                    </p><h3>Award of Degree</h3>
                  <p className="mb-4">Successful Candidates will be awarded B. Com/BBM Degree by University of Mysore , subject University regulations.</p>             
                </div> 
                
                 {/* <div className="row g-4">
                  {skillPrograms.map((program) => (
                    <div key={program.id} className="col-md-6" id={`skill-${program.id}`}>
                      <div className="course-card border rounded overflow-hidden shadow-sm hover-lift h-100">
                        <div className="course-img">
                          <img 
                            src={program.image} 
                            alt={program.title}
                            className="img-fluid w-100"
                            style={{ height: '200px', objectFit: 'cover' }}
                          />
                        </div>
                        <div className="course-content p-4">
                          <span className="course-category skill">{program.category}</span>
                          <h4 className="mt-2 mb-3">{program.title}</h4>
                          <p className="mb-3">{program.description}</p>
                          
                          <div className="course-details mb-3">
                            <span className="course-duration me-4">
                              <i className="fa fa-clock-o me-1"></i> {program.duration}
                            </span>
                            <span className="course-mode">
                              <i className="fa fa-laptop me-1"></i> {program.mode}
                            </span>
                          </div>
                          
                          <h5 className="mb-3">Course Highlights:</h5>
                          <ul className="course-highlights list-unstyled">
                            {program.highlights.map((highlight, index) => (
                              <li key={index} className="mb-1">
                                <i className="fa fa-check text-primary me-2"></i>
                                {highlight}
                              </li>
                            ))}
                          </ul>
                          
                          <div className="text-end mt-4">
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div> */}

                {/* Short Courses */}
                <div className="section-titlee mt-5">
                  <h6 className="section-title bg-white text-start text-primary pe-3">Short Courses</h6>
                  <h3>Quick Skill Boosters</h3>
                  <p className="mb-4">Specialized courses for specific skill enhancement</p>
                </div>
                
                <div className="row g-4">
                  {shortCourses.map((course) => (
                    <div key={course.id} className="col-md-4">
                      <div className="course-card border rounded shadow-sm hover-lift h-100">
                        <div className="course-content p-4 text-center h-100 d-flex flex-column">
                          <span className="course-category skill mb-3">{course.category}</span>
                          <h4 className="mb-3 flex-grow-1">{course.title}</h4>
                          <p className="mb-4 flex-grow-1">{course.description}</p>
                          
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="text-center">
            <h6 className="section-title bg-white text-center text-primary px-3">Testimonials</h6>
            <h1 className="mb-5">What Our Students Say</h1>
          </div> */}
          
          {/* Custom Testimonial Slider */}
          {/* <div className="testimonial-slider position-relative">
            <div className="testimonial-container">
              {testimonials.map((testimonial, index) => (
                <div
                  key={testimonial.id}
                  className={`testimonial-item text-center ${index === currentTestimonial ? 'active' : ''}`}
                  style={{ display: index === currentTestimonial ? 'block' : 'none' }}
                >
                  <img 
                    className="border rounded-circle p-2 mx-auto mb-3" 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                  />
                  <h5 className="mb-1">{testimonial.name}</h5>
                  <p className="text-muted mb-3">{testimonial.profession}</p>
                  <div className="testimonial-text bg-light text-center p-4 rounded">
                    <p className="mb-0">"{testimonial.text}"</p>
                  </div>
                </div>
              ))}
            </div> */}

            {/* Navigation Buttons */}
            {/* <button className="testimonial-prev" onClick={prevTestimonial}>
              <i className="fas fa-chevron-left"></i>
            </button>
            <button className="testimonial-next" onClick={nextTestimonial}>
              <i className="fas fa-chevron-right"></i> */}
            {/* </button> */}

            {/* Pagination Dots */}
            {/* <div className="testimonial-dots mt-4">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`testimonial-dot ${index === currentTestimonial ? 'active' : ''}`}
                  onClick={() => goToTestimonial(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div> */}

      {/* CSS Styles */}
      <style jsx>{`
        .section-titlee {
          margin-bottom: 2rem;
        }
        
        .section-titlee h3 {
          color: #333;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }
        
        .course-card {
          background: white;
          transition: all 0.3s ease;
        }
        
        .course-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }
        
        .course-category {
          display: inline-block;
          padding: 0.25rem 0.75rem;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .course-category.degree {
          background: rgba(78, 115, 223, 0.1);
          color: #4e73df;
        }
        
        .course-category.skill {
          background: rgba(40, 167, 69, 0.1);
          color: #28a745;
        }
        
        .course-details {
          color: #666;
          font-size: 0.9rem;
        }
        
        .course-highlights li {
          color: #555;
          line-height: 1.6;
        }
        
        .course-price {
          font-size: 1.5rem;
          font-weight: 600;
          color: #333;
        }
        
        .course-price span {
          font-size: 1rem;
          color: #666;
        }
        
        .btn-enroll {
          background: #4e73df;
          color: white;
          padding: 0.5rem 1.5rem;
          border-radius: 4px;
          text-decoration: none;
          transition: all 0.3s ease;
        }
        
        .btn-enroll:hover {
          background: #2e59d9;
          color: white;
          transform: translateY(-2px);
        }
        
        /* Testimonial Slider Styles */
        .testimonial-slider {
          position: relative;
          padding: 0 50px;
        }
        
        .testimonial-container {
          min-height: 300px;
        }
        
        .testimonial-item {
          transition: all 0.5s ease;
        }
        
        .testimonial-text {
          max-width: 600px;
          margin: 0 auto;
          position: relative;
        }
        
        .testimonial-text:before {
          content: '"';
          position: absolute;
          top: -20px;
          left: 20px;
          font-size: 60px;
          color: #4e73df;
          font-family: Georgia, serif;
          opacity: 0.2;
        }
        
        .testimonial-prev,
        .testimonial-next {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(78, 115, 223, 0.1);
          color: #4e73df;
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .testimonial-prev:hover,
        .testimonial-next:hover {
          background: #4e73df;
          color: white;
        }
        
        .testimonial-prev {
          left: 0;
        }
        
        .testimonial-next {
          right: 0;
        }
        
        .testimonial-dots {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin-top: 20px;
        }
        
        .testimonial-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          border: none;
          background: #ddd;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .testimonial-dot.active {
          background: #4e73df;
          transform: scale(1.3);
        }
        
        .testimonial-dot:hover {
          background: #4e73df;
        }
        
        /* Hover effects */
        .hover-lift {
          transition: all 0.3s ease;
        }
        
        .hover-lift:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }
        
        /* Responsive adjustments */
        @media (max-width: 768px) {
          .course-card .row {
            flex-direction: column;
          }
          
          .course-card .col-md-4 {
            width: 100%;
            height: 250px;
          }
          
          .testimonial-slider {
            padding: 0 40px;
          }
          
          .testimonial-prev,
          .testimonial-next {
            width: 35px;
            height: 35px;
          }
        }
      `}</style>
    </>
  );
};

export default Courses;